import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";


export const get_category = createAsyncThunk(
    'product/get_category',
    async(_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.get('/home/get-categorys')
            // console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method 
export const get_products = createAsyncThunk(
    'product/get_products',
    async(_, { fulfillWithValue,rejectWithValue }) => {
        try {
            const {data} = await api.get('/home/get-products')
             console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method 


export const price_range_product = createAsyncThunk(
    'product/price_range_product',
    async(_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.get('/home/price-range-latest-product')
             console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method 

export const query_products = createAsyncThunk(
    'product/query_products',
    async(query , { fulfillWithValue,rejectWithValue }) => {
        try {
            const {data} = await api.get(`/home/query-products?category=${query.category}&&rating=${query.rating}&&lowPrice=${query.low}&&highPrice=${query.high}&&sortPrice=${query.sortPrice}&&pageNumber=${query.pageNumber}&&searchValue=${query.searchValue ? query.searchValue : ''} `)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method 

export const product_details = createAsyncThunk(
    'product/product_details',
    async(slug, { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.get(`/home/product-details/${slug}`)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method 

export const customer_review = createAsyncThunk(
    'review/customer_review',
    async(info, { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.post('/home/customer/submit-review',info)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.respone)
            return rejectWithValue(error)
        }
    }
)
// End Method 


export const get_reviews = createAsyncThunk(
    'review/get_reviews',
    async({productId, pageNumber}, { fulfillWithValue, rejectWithValue}) => {
        try {
            const {data} = await api.get(`/home/customer/get-reviews/${productId}?pageNo=${pageNumber}`)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.respone)
            return rejectWithValue(error)
        }
    }
)
// End Method 


export const get_banners = createAsyncThunk(
    'banner/get_banners',
    async( _ , { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.get(`/banners`)
            //  console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.respone)
            return rejectWithValue(error)
        }
    }
)
// End Method

export const get_shops = createAsyncThunk(
    'home/get_shops',
    async(limit, { fulfillWithValue, rejectWithValue }) => {
        try {
            const url = limit ? `/home/get-shops?limit=${limit}` : '/home/get-shops'
            const {data} = await api.get(url)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method

export const get_shop_details = createAsyncThunk(
    'home/get_shop_details',
    async(shopId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.get(`/home/shop-details/${shopId}`)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method

export const query_shop_products = createAsyncThunk(
    'home/query_shop_products',
    async({shopId, category, sortPrice, pageNumber}, { fulfillWithValue, rejectWithValue }) => {
        try {
            const {data} = await api.get(`/home/shop-products/${shopId}?category=${category}&&sortPrice=${sortPrice}&&pageNumber=${pageNumber}`)
            return fulfillWithValue(data)
        } catch (error) {
            console.log(error.response)
            return rejectWithValue(error)
        }
    }
)
// End Method 




export const homeReducer = createSlice({
    name: 'home',
    initialState:{
        categorys : [],
        products : [],
        totalProduct : 0,
        parPage: 3,
        latest_product : [],
        topRated_product : [],
        discount_product : [],
        priceRange : {
            low: 0,
            high: 100
        },
        product: {},
        relatedProducts: [],
        moreProducts: [],
        errorMessage : '',
        successMessage: '',
        totalReview: 0,
        rating_review: [],
        reviews : [],
        banners: [],
        shops: [],
        shop: null,
        shopProducts: [],
        totalShopProduct: 0,
        loader: false
    },
    reducers : {

        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        }

    },
    extraReducers: (builder) => {
        builder
        .addCase(get_category.fulfilled, (state, { payload }) => {
            state.categorys = payload.categorys;
        })
        .addCase(get_products.pending, (state) => {
            state.loader = true;
        })
        .addCase(get_products.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.products = payload.products;
            state.latest_product = payload.latest_product;
            state.topRated_product = payload.topRated_product;
            state.discount_product = payload.discount_product;
        })
        .addCase(get_products.rejected, (state) => {
            state.loader = false;
        })
        .addCase(price_range_product.pending, (state) => {
            state.loader = true;
        })
        .addCase(price_range_product.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.latest_product = payload.latest_product;
            state.priceRange = payload.priceRange;
        })
        .addCase(price_range_product.rejected, (state) => {
            state.loader = false;
        })
        .addCase(query_products.pending, (state) => {
            state.loader = true;
        })
        .addCase(query_products.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.products = payload.products;
            state.totalProduct = payload.totalProduct;
            state.parPage = payload.parPage;
        })
        .addCase(query_products.rejected, (state) => {
            state.loader = false;
        })
        .addCase(product_details.pending, (state) => {
            state.loader = true;
        })
        .addCase(product_details.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.product = payload.product;
            state.relatedProducts = payload.relatedProducts;
            state.moreProducts = payload.moreProducts;
        })
        .addCase(product_details.rejected, (state) => {
            state.loader = false;
        })
        .addCase(customer_review.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message;
        })

        .addCase(get_reviews.fulfilled, (state, { payload }) => {
            state.reviews = payload.reviews;
            state.totalReview = payload.totalReview;
            state.rating_review = payload.rating_review;
        })

        .addCase(get_banners.fulfilled, (state, { payload }) => {
            state.banners = payload.banners;
        })

        .addCase(get_shops.fulfilled, (state, { payload }) => {
            state.shops = payload.shops;
        })

        .addCase(get_shop_details.pending, (state) => {
            state.loader = true;
        })
        .addCase(get_shop_details.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.shop = payload.shop;
        })
        .addCase(get_shop_details.rejected, (state) => {
            state.loader = false;
        })

        .addCase(query_shop_products.pending, (state) => {
            state.loader = true;
        })
        .addCase(query_shop_products.fulfilled, (state, { payload }) => {
            state.loader = false;
            state.shopProducts = payload.products;
            state.totalShopProduct = payload.totalProduct;
            state.parPage = payload.parPage;
        })
        .addCase(query_shop_products.rejected, (state) => {
            state.loader = false;
        })

    }
})
export const {messageClear} = homeReducer.actions
export default homeReducer.reducer